(($, duo, undefined) => {
  Drupal.behaviors.coachslider = {

    attach: function(context, settings) {
      if (context !== document) {
        return;
      }

      this.init(context, settings);
    },

    init: function(context, settings) {

      // setup slider:
      // -> swiperjs doesn't support IE:
      if(!duo.Utils.isIE()) {
        this.setupSlider(context);
      } else {
        $(context).find('.p-coaches-block').addClass('js-ie-ready');
      }
    },

    setupSlider: function(context) {
      const self = this;

      const $coachBlocks = $(context).find('.p-coaches-block');
      $coachBlocks.each(function(index, element) {
        const $coachBlock = $(element);

        // get elements necessary for swiper:
        const $coachSliderContainer = $coachBlock.find('.p-coaches-block__views');
        const $coachSliderWrapper = $coachBlock.find('.p-coaches-block__views-inner');
        const $coachSliderSlide = $coachBlock.find('.p-coaches-block__view');
        const $coachSliderNavigation = $coachBlock.find('.p-coaches-block__navigation');
        const $coachSliderMobileNavigation = $coachBlock.find('.p-coaches-block__mobile-navigation');

        // add "swiper" classes to slider elements:
        $coachSliderContainer.addClass('swiper-container');
        $coachSliderWrapper.addClass('swiper-wrapper');
        $coachSliderSlide.addClass('swiper-slide');

        // initialize swiper:
        const swiper = new Swiper($coachSliderContainer[0], {
          spaceBetween: 0,
          effect: 'fade',
          autoHeight: false,
          allowTouchMove: false,
          on: {
            slideChange: function(sw) {
              // -> indicate active slide navigation item:
              const realSlideIndex = sw.realIndex;
              const $newSlide = $coachSliderContainer.find('.swiper-slide').eq(realSlideIndex);
              const newSlideDataId = $newSlide.attr('data-itemid');
              // --> desktop navigation:
              $coachSliderNavigation.find('.js-slide-active').removeClass('js-slide-active');
              const $newSlideNavItem = $coachSliderNavigation.find(`.p-coaches-block__navlist-item[data-itemid=${newSlideDataId}]`);
              $newSlideNavItem.addClass('js-slide-active');
              // --> mobile navigation:
              $coachSliderMobileNavigation.find('.js-slide-active').removeClass('js-slide-active');
              const $newSlideMobileNavItem = $coachSliderMobileNavigation.find(`.js-coachslider-mobile-slidebutton[data-itemid=${newSlideDataId}]`);
              $newSlideMobileNavItem.addClass('js-slide-active');
            },
            init: function(sw) {
              // -> indicate active slide navigation item:
              const $newSlide = $coachSliderContainer.find('.swiper-slide').eq(0);
              const newSlideDataId = $newSlide.attr('data-itemid');
              // --> desktop navigation:
              const $newSlideNavItem = $coachSliderNavigation.find(`.p-coaches-block__navlist-item[data-itemid=${newSlideDataId}]`);
              $newSlideNavItem.addClass('js-slide-active');
              // --> mobile navigation:
              const $newSlideMobileNavItem = $coachSliderMobileNavigation.find(`.js-coachslider-mobile-slidebutton[data-itemid=${newSlideDataId}]`);
              $newSlideMobileNavItem.addClass('js-slide-active');
            },
          }
        });

        // add "js-processed" class to the coach-block:
        $coachBlock.addClass('js-processed');

        // swiper navigation:
        $coachBlock.on('click', '.js-coachslider-slidebutton, .js-coachslider-mobile-slidebutton', function() {
          const selectedSlideIndex = $(this).attr('data-index');
          swiper.slideTo(selectedSlideIndex, 250);
        });
      });
    }

  };
})(jQuery, window.duo = window.duo || {});
